import { BOARD } from '../types';

const initialState = {
  activeBoard: null,
};

const boardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOARD.SET_ACTIVE_BOARD:
      return {
        activeBoard: action.activeBoard,
      };

    default:
      return state;
  }
};

export default boardsReducer;